exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".App {\n  text-align: center; }\n\n.App-logo {\n  animation: App-logo-spin infinite 20s linear;\n  height: 80px; }\n\n.App-header {\n  background-color: #222;\n  height: 150px;\n  padding: 20px;\n  color: white; }\n\n.App-title {\n  font-size: 1.5em; }\n\n.App-intro {\n  font-size: large; }\n\n.containerFullWidth {\n  width: 100%; }\n\n.prism-tabs span {\n  font-family: Montserrat !important; }\n\n.text-field-input input {\n  font-family: Montserrat !important; }\n\n.text-field-input label:nth-child(1) {\n  font-family: Montserrat !important;\n  color: #4a4a4a; }\n\n.text-field-input div::after {\n  border-bottom: 2px #4a4a4a !important; }\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg); }\n  to {\n    transform: rotate(360deg); } }\n\n@media only screen and (max-width: 500px) {\n  .containerFullWidth {\n    width: 100% !important; } }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/App.scss
// module id = 371
// module chunks = 0